import PageContainer from '../components/common/PageContainer';
import LoginForm from '../components/account/LoginForm';

export default function LoginPage() {
  return (
    <PageContainer>
      <LoginForm className="max-w-lg mx-auto mt-10" />
      <div className="mt-4 text-sm text-center text-zinc-500">
        مدیریت فرایند
        <span className="px-2 text-zinc-600 font-bold">آفاق کسب و کار</span>
      </div>
    </PageContainer>
  );
}
